import { lazy, Suspense } from 'react'
import { usePath, matchRoute } from './lib/router.js'
import Projects from './pages/Projects.jsx'

const Planner = lazy(() => import('./pages/Planner.jsx'))
const Workshop = lazy(() => import('./pages/Workshop.jsx'))
const PrintEditor = lazy(() => import('./pages/PrintEditor.jsx'))

export function Loading({ text = 'Lade …' }) {
  return (
    <div className="h-full flex items-center justify-center gap-2 text-outline" style={{ fontSize: 13 }}>
      <span className="material-symbols-outlined animate-spin" style={{ fontSize: 18, color: 'var(--sage)' }}>progress_activity</span>
      {text}
    </div>
  )
}

export default function App() {
  const route = matchRoute(usePath())
  return (
    <Suspense fallback={<Loading />}>
      {route.page === 'plan' && <Planner key={route.id} id={route.id} />}
      {route.page === 'werkstatt' && <Workshop key={route.id} id={route.id} />}
      {route.page === 'print' && <PrintEditor key={route.id} id={route.id} />}
      {route.page === 'projects' && <Projects key={route.kind} kind={route.kind} />}
    </Suspense>
  )
}
